module.exports = __webpack_public_path__ + "static/img/case-kyj-page-bg-03.8e06ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/kyj/case-kyj-page-bg-03.jpg
// module id = oYRh
// module chunks = 1